import React, { useContext, useState } from 'react'
import { Pressable, View, Text } from 'react-native'
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import { TouchableOpacity } from 'react-native-gesture-handler'
import { useTranslation } from 'react-i18next'
import { useNavigation, useRoute } from '@react-navigation/native'
import { styles } from './styles'
import { StackNavigationProp } from '@react-navigation/stack'
import { LogoutModal } from '../LogoutModal/LogoutModal'
import { AlertsContext } from '../../context/Alerts/AlertsContext'
import { AuthContext } from '../../context/Auth/AuthContext'
import { RootParams } from '../../navigator/types'
import { AlertIcon, ExitIcon } from '../Svg'
import { DOBRA_BOLD } from '../../theme/fonts'

type NavigationProps = StackNavigationProp<RootParams, 'Notifications'>

interface Props {
  notificationsHeader: boolean
  backButton: boolean
  title?: string
  backButtonFunction?: () => void | undefined
}

export const LogoutBigIcon = ({
  notificationsHeader,
  backButton,
  title,
  backButtonFunction,
}: Props) => {
  const {
    user: { areaSelected },
  } = useContext(AuthContext)
  const { handleEnableIcon } = useContext(AlertsContext)
  const navigation = useNavigation<NavigationProps>()
  const { t } = useTranslation()
  const [logoutAlert, setLogoutAlert] = useState(false)

  const handleCloseAlert = () => setLogoutAlert(false)
  const route = useRoute()

  return (
    <>
      {logoutAlert && <LogoutModal handleLogoutAlert={handleCloseAlert} />}

      <View style={[styles.container]}>
        {backButton && (
          <Pressable
            onPress={() => {
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              backButtonFunction
                ? backButtonFunction()
                : navigation.canGoBack()
                ? navigation.goBack()
                : navigation.navigate('AreaSelectorScreen')
            }}
          >
            <View style={{ flexDirection: 'row', alignItems: 'center' }}>
              <FontAwesomeIcon icon={faChevronLeft} size={30} color={'#FFFAFA'} />
              {!backButton && (
                <Text
                  style={{
                    fontFamily: DOBRA_BOLD,
                    fontSize: 22,
                    color: '#FFFEFE',
                    marginLeft: 10,
                  }}
                >
                  {t('Registros')}
                </Text>
              )}
            </View>
          </Pressable>
        )}

        <Text style={styles.title}>{title}</Text>

        <View style={styles.iconContainer}>
          {notificationsHeader && (
            <TouchableOpacity
              onPress={() => {
                if (route.name === 'Alerts') return
                if (route.name !== 'HomeScreen') {
                  navigation.replace('Alerts')
                }

                navigation.navigate('Alerts')
              }}
              disabled={!handleEnableIcon(areaSelected)}
              style={{ marginRight: 20 }}
            >
              <AlertIcon />

              {handleEnableIcon(areaSelected) && <View style={styles.alertIcon}></View>}
            </TouchableOpacity>
          )}
          <TouchableOpacity
            onPress={() => {
              setLogoutAlert(true)
            }}
          >
            <ExitIcon />
          </TouchableOpacity>
        </View>
      </View>
    </>
  )
}
